//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions } from "vuex";
import BarChart from "../Charts/BarChart.vue"

export default {
  components: { BarChart },
  data() {
    return {
      date: 
      {
          label: "I dag",
          fromDate: this.formatDate(new Date()),  
      },
      pickDateOptions: [
        {
           label: "I dag",
           fromDate: this.formatDate(new Date()),  
        },
        {
           label: "Denne uken",
           fromDate: this.getStartOfWeek(),  
        },
        {
           label: "Denne måneden",
           fromDate: this.getStartOfMonth(), 
        },
        {
           label: "Dette året",
           fromDate: this.getStartOfYear(),
        },
      ],
      orderCountings: [],
      orderLabels: ['Ordre mottatt', 'Ordre levert', 'Ordre plukket', 'Varer mottatt'],
    };
  },
  async mounted() {
    await this.getorderCountingsData();   
  },

  methods: {
    ...mapActions("main", ["getOrderCountings"]),

    async getorderCountingsData() {
      var data = await this.getOrderCountings(this.date);
      this.orderCountings = Object.values(data);
    },

    formatDate(date) {
      let year = date.getFullYear();
      let month = date.getMonth() + 1; 
      let day = date.getDate(); 

      let formattedMonth = month < 10 ? `0${month}` : month;
      let formattedDay = day < 10 ? `0${day}` : day;

      return `${year}-${formattedMonth}-${formattedDay}`;
    },

    getStartOfYear() {
      var date = new Date();
      date.setMonth(0); // January is month 0 in JavaScript Date object
      date.setDate(1); // Set the day of the month to 1

      return this.formatDate(date);
    },

    getStartOfWeek() {
      let today = new Date();
      let dayOfWeek = today.getDay(); // 0 (Sunday) to 6 (Saturday)

      // Calculate how many days ago was the most recent Sunday
      let daysAgo = dayOfWeek;
      let startOfWeek = new Date(today);
      startOfWeek.setDate(today.getDate() - daysAgo);

      // Reset hours, minutes, seconds, and milliseconds to 0 for a clean start of the day
      startOfWeek.setHours(0, 0, 0, 0);

      // Format month and day to always have two digits (e.g., 01, 02, ..., 09, 10, ...)
      let month = startOfWeek.getMonth() + 1; // Adding 1 because getMonth() returns 0-based index
      let formattedMonth = month < 10 ? `0${month}` : month;
      let day = startOfWeek.getDate();
      let formattedDay = day < 10 ? `0${day}` : day;

      // Construct the YYYY-MM-DD format string for the start of the week
      let startOfWeekFormatted = `${startOfWeek.getFullYear()}-${formattedMonth}-${formattedDay}`;

      return startOfWeekFormatted;
    },

    getStartOfMonth() {
      let today = new Date();
      let startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);

      // Reset hours, minutes, seconds, and milliseconds to 0 for a clean start of the day
      startOfMonth.setHours(0, 0, 0, 0);

      // Format month and day to always have two digits (e.g., 01, 02, ..., 09, 10, ...)
      let month = startOfMonth.getMonth() + 1; // Adding 1 because getMonth() returns 0-based index
      let formattedMonth = month < 10 ? `0${month}` : month;
      let day = startOfMonth.getDate();
      let formattedDay = day < 10 ? `0${day}` : day;

      // Construct the YYYY-MM-DD format string for the start of the month
      let startOfMonthFormatted = `${startOfMonth.getFullYear()}-${formattedMonth}-${formattedDay}`;

      return startOfMonthFormatted;
    }
  },
};
